






























import {Component, Vue} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';
import S3Image from '@/components/S3Image.vue';
import DlgModeratorsNew from '@/modules/admin/moderators/_components/DlgModeratorsNew.vue';
import Card from '@/components/material/Card.vue';
import DlgModeratorsDelete from '@/modules/admin/moderators/_components/DlgModeratorsDelete.vue';
import DlgModeratorsForgot from '@/modules/admin/moderators/_components/DlgModeratorsForgot.vue';

@Component({
  components: {
    DlgModeratorsForgot,
    DlgModeratorsDelete,
    Card,
    DlgModeratorsNew,
    S3Image,
  },
})
export default class ModeratorsList extends Vue {
  private loading: boolean = false;
  @Action('admin/moderators/read') private readModerators!: () => Promise<boolean>;
  @Getter('admin/moderators/all') private moderators!: any[];

  private headers: any = [
    {
      text: 'Name',
      align: 'left',
      value: 'username',
    },
    {
      text: 'Email',
      align: 'left',
      sortable: false,
      value: 'email',
    },
    {
      text: 'Status',
      align: 'left',
      sortable: false,
      value: 'status',
    },
    {
      text: '',
      align: 'left',
      sortable: false,
      value: '',
    },
  ];

  private mounted() {
    this.loading = true;

    this.readModerators()
      .then((success) => {
        if (success) {
          this.loading = false;
        } else {
          throw new Error('Some Error, handle it');
        }
      })
      .catch((err) => {
        this.loading = false;
      });
  }
}
